interface ListBlock {
  items: ListItem[];
  extraInfo?: { text: string };
}

interface ListItem {
  icon?: string;
  body?: string;
  title?: string;
}

interface TitleGroup {
  icon?: string;
  title?: string;
  subtitle?: string;
}

interface InfoLink {
  external?: boolean;
  text?: string;
  url?: string;
  partnerName?: string;
  partnerType?: string;
}

// Base type with common properties shared between V1 and V2
type GreenlightBase = {
  titleGroup: TitleGroup;
  infoLink?: InfoLink;
  listBlock?: ListBlock;
};

// V1 API response type
type GreenlightView = GreenlightBase & {
  preCheckTitle?: string;
  summaryGroup?: { title: string; summaries: string[] };
  button?: { title: string; action: string; external: boolean };
};

// V2 API response type
type GreenlightV2 = GreenlightBase & {
  reportInfo?: {
    buttonText: string;
    reportType: ReportType;
  };
};

const REPORT_TYPES = {
  FREE_REPORT: 'FREE_REPORT',
  COMPLETE_REPORT: 'COMPLETE_REPORT',
} as const;

type ReportType = (typeof REPORT_TYPES)[keyof typeof REPORT_TYPES];

export { REPORT_TYPES };

export type {
  ListBlock,
  ListItem,
  TitleGroup,
  InfoLink,
  GreenlightView,
  GreenlightV2,
  ReportType,
};
